import * as React from "react";
import FormField from "components/FormField/FormField";
import { FieldWrapper } from "components/WorkItem/Form/Field/Field.styles";
import { FieldsWrapper, VehicleSectionWrapper } from "components/WorkItem/Form/Section.styles";
import { Header, DarkText } from "components/WorkItem/Form/Vehicle/Section.styles";
import { ButtonPrimary } from "components/WorkItem/Form/Footer.styles";

const MiscFee = ({
  onAddMiscFee,
  onSetMiscFeeValue,
  miscFees
}) => {
    const handleChange = (value, item) => {
        try {
            miscFees.map(a => {
                a.map(b => {
                    if (b.sequence === item.id) {
                        b.value = value;
                    }
                });
            });
        }
        catch (Ex) { }
    onSetMiscFeeValue(miscFees);
  }

  const handleRemoveMiscFee = (e) => {
    let miscFeeIndex = 0;
    miscFees.map((a,index) => {
      a.map(b => {
        if (b.key === e.currentTarget.id){miscFeeIndex = index; }
      });
    });
    miscFees.splice(miscFeeIndex, 1);
    onSetMiscFeeValue(miscFees);
  }

  let formFieldsWrapper = [];
  let formFields = [];
  let miscFeeid = "";
  miscFees.map( (x, index) => {
      formFields = [];
      x.map( field => {
        miscFeeid = field.key;
        formFields.push(<FieldWrapper key={field.sequence}>
              <FormField
                  key = {field.sequence}
                  id = {field.sequence}
                  title = {field.helpText}
                  item = {field}
                  items = {field.items}
                  placeholder = {field.helpText}
                  value = {field.fieldType === "Currency" ? Number(field.value) : field.value}
                  isRequired = {true}
                  onChange = {handleChange}
                  disabled = {false}
                  groupField = {field.groupField}
                  fieldType = {field.fieldType}
                />
          </FieldWrapper>);
        }
      );
      formFieldsWrapper.push(
        <FieldsWrapper key={`fieldsWrapper${index}`}>
          {formFields}
          <FieldWrapper>
            <ButtonPrimary id={miscFeeid} onClick={handleRemoveMiscFee}>
              Remove
            </ButtonPrimary>
          </FieldWrapper>
        </FieldsWrapper>);
    }
  );
  
  return (
    <div>
      <VehicleSectionWrapper>
        <Header>
          <DarkText>Miscellaneous fees</DarkText>
          <button onClick={onAddMiscFee}>Add</button>
        </Header>
      </VehicleSectionWrapper>
      {formFieldsWrapper}
    </div>
  );
}

export default MiscFee;